// extracted by mini-css-extract-plugin
export var externalLink = "_6s-0";
export var internalLinkLabel = "_6s-1";